import {
  ApplicationConfig,
  provideZonelessChangeDetection,
  // provideExperimentalZonelessChangeDetection,
} from '@angular/core';
import {
  provideRouter,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling,
  withViewTransitions,
} from '@angular/router';

import {
  provideClientHydration,
  withEventReplay,
  withHttpTransferCacheOptions,
  withIncrementalHydration,
} from '@angular/platform-browser';
import { routes } from './app.routes';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { apiPrefixInterceptor, httpInterceptor, SeoMetaService } from './core';
import { RouteReuseStrategy, DetachedRouteHandle, ActivatedRouteSnapshot } from '@angular/router';
// import * as Sentry from '@sentry/angular';

const seoProviders = [SeoMetaService];

const sentryProviders = [
  // {
  //   provide: ErrorHandler,
  //   useValue: Sentry.createErrorHandler(),
  // },
  // {
  //   provide: Sentry.TraceService,
  //   deps: [Router],
  // },
  // {
  //   provide: APP_INITIALIZER,
  //   useFactory: () => () => {},
  //   deps: [Sentry.TraceService],
  //   multi: true,
  // },
];

class NoReuseStrategy implements RouteReuseStrategy {
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null): void {}

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return null;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return false;
  }
}

export const appConfig: ApplicationConfig = {
  providers: [
    ...seoProviders,
    ...sentryProviders,
    provideZonelessChangeDetection(),
    // provideExperimentalZonelessChangeDetection(),
    provideAnimations(),
    provideHttpClient(
      withFetch(),
      withInterceptors([apiPrefixInterceptor, httpInterceptor]),
    ),
    provideRouter(
      routes,
      withViewTransitions(),
      // withEnabledBlockingInitialNavigation(),
      withInMemoryScrolling({ scrollPositionRestoration: 'top' }),
    ),
    provideClientHydration(
      withEventReplay(),
      withIncrementalHydration(),
      withHttpTransferCacheOptions({ includePostRequests: true }),
    ),
    { provide: RouteReuseStrategy, useClass: NoReuseStrategy },
  ],
};

// https://angular.dev/guide/incremental-hydration
